import Alert from '@mui/material/Alert';

const ErrorAlert = ({error = null}) => {
  if (!error) return null;
  const message = (
    error?.data?.errors?.[0]
    || error?.message
    || 'An unexpected error occurred.'
  );
  return (
    <Alert severity="error">
      {message}
    </Alert>
  );
};

export default ErrorAlert;